export const PHONE_MASK = '+7 (000) 000 00 00';

export function maskValue(value: string, mask: string) {
  if (value.length !== 10) {
    return null;
  }

  const chars = mask.split('');
  const digits = value.split('');

  let result = '';
  for (const char of chars) {
    result += char === '0' ? digits.shift() : char;
  }

  return result;
}
